import {Bin} from './bin';
import type {Board} from './board';
import type {PlacedBinDef} from './common/placed-bin-def';

export class PlacedBin {

    public static createFromDef(placedBinDef: PlacedBinDef, board?: Board): PlacedBin {
        let {x, y, w, h} = placedBinDef;

        if (board && board.binsGap) {
            const posInc = -board.binsGap;
            const sizeInc = board.binsGap * 2;

            x += posInc;
            y += posInc;
            w += sizeInc;
            h += sizeInc;
        }

        const bin = new Bin(w, h);
        const placedBin = new PlacedBin(bin, x, y);

        placedBin.isParent = !!placedBinDef.isParent;

        return placedBin;
    }

    public w: number;
    public h: number;
    public nextX: number;
    public nextY: number;
    public right: number;
    public bottom: number;
    public isParent: boolean = false;

    constructor(
        public bin: Bin,
        public x: number,
        public y: number
    ) {
        this.w = bin.w;
        this.h = bin.h;

        this.updateMetaValues();
    }

    public shiftPos(dx: number, dy: number): PlacedBin {
        this.x += dx;
        this.y += dy;

        this.updateMetaValues();

        return this;
    }

    private updateMetaValues(): void {
        this.nextX = this.x + this.w;
        this.nextY = this.y + this.h;
        this.right = this.nextX - 1;
        this.bottom = this.nextY - 1;
    }

}
